import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@iso/lib//helpers/api';
import { types, actions } from './reducer';
import OfferService from '@iso/services/SettingsService/OfferService';

function* deleteOffer({ id }) {
    try {
        yield call(OfferService.deleteOne, id);
        yield put(actions.deleteOfferSucceeded(id));
    } catch (error) {
        yield put(actions.deleteOfferFailed(extractError(error)));
    }
}

function* watchDeleteOffer() {
    yield takeEvery(
        types.REQUEST_DELETE_OFFER,
        deleteOffer,
    );
}

function* deleteSaga() {
    yield all([
        fork(watchDeleteOffer),
    ]);
}

export default deleteSaga;
